import React from "react";
import { Chevron } from "../../assets/svgs/icons";
import CardResultGrade, { GradeType } from "./result/Grade";

export interface CardResultProps {
  title: string;
  interviewType: string;
  grade: GradeType;
  interviewDate: string;
  onViewResult?: () => void;
  className?: string;
}

const CardResult: React.FC<CardResultProps> = ({
  title,
  interviewType,
  grade,
  interviewDate,
  onViewResult,
  className = "",
}) => {
  return (
    <div
      className={`
        box-border
        border border-solid border-[#e2d5fc]
        rounded-[20px] p-4
        flex flex-col gap-4
        ${className}
      `}
    >
      {/* Title and action button */}
      <div className="flex items-center justify-between w-full">
        <h3 className="font-bold text-[16px] leading-[20px] tracking-[-0.32px] text-[#212121]">
          {title}
        </h3>

        <button
          type="button"
          onClick={onViewResult}
          className="flex items-center justify-center h-8 rounded-[4px]"
        >
          <span className="font-medium text-[14px] leading-[20px] tracking-[-0.28px] text-[#6d2ef2] underline">
            결과보기
          </span>
          <Chevron className="w-5 h-5 [&_path]:fill-[#6d2ef2]" />
        </button>
      </div>

      {/* Interview type and grade */}
      <div className="flex flex-wrap gap-3 w-full">
        <div className="flex-1 min-w-0 flex flex-col gap-1">
          <p className="font-normal text-[12px] leading-[16px] tracking-[-0.24px] text-[#888888]">
            면접유형
          </p>
          <p className="font-medium text-[14px] leading-[20px] tracking-[-0.28px] text-[#212121]">
            {interviewType}
          </p>
        </div>

        <div className="flex-1 min-w-0 flex flex-col gap-1">
          <p className="font-normal text-[12px] leading-[16px] tracking-[-0.24px] text-[#888888]">
            종합결과
          </p>
          <CardResultGrade grade={grade} />
        </div>
      </div>

      {/* Interview date */}
      <div className="w-full text-right">
        <p className="font-normal text-[12px] leading-[16px] tracking-[-0.24px] text-[#888888]">
          면접일 {interviewDate}
        </p>
      </div>
    </div>
  );
};

export default CardResult;
